module.exports = __webpack_public_path__ + "img/garbage-orange.17bc7a9c.svg";